/* ============================================================
   lab-article.js — Lab Effects article behavior.
   • Reading-progress bar (tracks .ar-col)
   • "On this page" TOC AUTO-BUILT from the body's H2 headings
     (assigns stable ids, fills #arToc, scrollspy + smooth-scroll)
   • FAQ accordion · copy-link share button
   Vanilla, accessible, no deps. Re-binds on Shopify section
   load/select so it works in the Theme Editor. Honors reduced-motion.
   ============================================================ */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function navOffset() {
    var v = getComputedStyle(document.body).getPropertyValue('--header-height');
    return (parseInt(v, 10) || 84);
  }

  function slugify(s) {
    return (s || '').toLowerCase().trim()
      .replace(/[™®]/g, '')      // strip ™ ®
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 60) || 'section';
  }

  function initProgress() {
    var bar = document.getElementById('arProgress');
    var article = document.querySelector('.ar-col');
    if (!bar || !article) return null;
    return function () {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight + 200;
      var done = Math.min(Math.max(-rect.top + 120, 0), total);
      bar.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
    };
  }

  /* Build the TOC from the rendered H2s in the reading column. */
  function initToc() {
    var toc = document.getElementById('arToc');
    var prose = document.querySelector('.ar-prose');
    if (!toc || !prose) return null;
    var nav = toc.querySelector('nav');
    if (!nav) return null;

    var heads = [].slice.call(prose.querySelectorAll('h2')).filter(function (h) {
      return !h.closest('.ar-sources') && h.textContent.trim().length;
    });
    if (!heads.length) { toc.setAttribute('hidden', ''); return null; }

    nav.innerHTML = '';
    var seen = {};
    var targets = [];
    heads.forEach(function (h) {
      var base = h.id || slugify(h.textContent);
      var id = base;
      if (seen[base]) { id = base + '-' + seen[base]; seen[base]++; } else { seen[base] = 1; }
      h.id = id;
      targets.push(h);
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var top = h.getBoundingClientRect().top + window.scrollY - (navOffset() + 20);
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
      nav.appendChild(a);
    });
    toc.removeAttribute('hidden');

    var links = [].slice.call(nav.querySelectorAll('a'));
    return function () {
      var pos = window.scrollY + navOffset() + 60;
      var idx = 0;
      targets.forEach(function (t, i) { if (t.offsetTop <= pos) idx = i; });
      links.forEach(function (a, i) { a.classList.toggle('active', i === idx); });
    };
  }

  function initFaq(scope) {
    [].slice.call((scope || document).querySelectorAll('.ar-faq-q')).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.ar-faq-item');
        var ans = item.querySelector('.ar-faq-a');
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        ans.style.maxHeight = open ? (ans.scrollHeight + 'px') : '0px';
      });
    });
  }

  function initCopy(scope) {
    var btn = (scope || document).querySelector('#arCopy');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    var linkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>';
    var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    btn.innerHTML = '<span class="ar-copy-ico">' + linkSvg + '</span>';
    var ico = btn.querySelector('.ar-copy-ico');
    var tip = document.createElement('span');
    tip.className = 'ar-copied';
    tip.textContent = 'Copied';
    btn.appendChild(tip);
    var t1, t2;
    btn.addEventListener('click', function () {
      var show = function () {
        ico.innerHTML = checkSvg;
        tip.classList.add('show');
        clearTimeout(t1); clearTimeout(t2);
        t1 = setTimeout(function () { tip.classList.remove('show'); }, 1400);
        t2 = setTimeout(function () { ico.innerHTML = linkSvg; }, 1700);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(show, show);
      else show();
    });
  }

  /* Tables: flag the ones that really scroll sideways, so the CSS can show an
     edge fade + "swipe" hint on those only. is-scrolled retires the hint after
     the first swipe; at-end drops the fade once the last column is in view. */
  function initTables() {
    var boxes = document.querySelectorAll('.ar-table');
    Array.prototype.forEach.call(boxes, function (box) {
      var wrap = box.parentNode;
      if (!wrap || !wrap.classList.contains('ar-table-wrap')) return;
      function update() {
        var over = box.scrollWidth - box.clientWidth > 2;
        wrap.classList.toggle('is-scrollable', over);
        wrap.classList.toggle('at-end', !over || box.scrollLeft + box.clientWidth >= box.scrollWidth - 2);
      }
      if (!box._leTbl) {
        box._leTbl = true;
        box.addEventListener('scroll', function () {
          if (box.scrollLeft > 4) wrap.classList.add('is-scrolled');
          update();
        }, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(update).observe(box);
        else window.addEventListener('resize', update);
      }
      update();
    });
  }

  var progress, spy;
  function boot() {
    initTables();
    progress = initProgress();
    spy = initToc();
    initFaq(document);
    initCopy(document);
    if (progress) progress();
    if (spy) spy();
  }

  window.addEventListener('scroll', function () { if (progress) progress(); if (spy) spy(); }, { passive: true });
  window.addEventListener('resize', function () { if (progress) progress(); if (spy) spy(); });

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Theme Editor: re-init when sections re-render or are selected */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function () { initFaq(document); initCopy(document); });
})();
